document.querySelectorAll(".js-sort-btn-change").forEach(button => {
    button.addEventListener("click", function() {
      const selectValue = this.getAttribute("data-sort-value");
  
      const sortByElement = document.getElementById("SortBy");
      if (sortByElement) {
        sortByElement.value = "";
        sortByElement.dispatchEvent(new Event("change")); // Simulating jQuery's `trigger('change')`
  
        sortByElement.value = selectValue;
        const option = sortByElement.querySelector(`option[value="${selectValue}"]`);
        if (option) {
          option.setAttribute("selected", "true");
        }
        sortByElement.dispatchEvent(new Event("change"));
      }
  
      window.location.search = new URLSearchParams({ sort_by: selectValue }).toString();
    });
});
